import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import Tabs, { TabsProps } from './Tabs';
import { AccessibilityStore, DataStore, SuperscriptScope } from '../stores';
import { getFundTypeId } from '../utils/getFundTypeId';
import { FundType } from '../models/configuration/FundType';
import { camelCase } from '@kurtosys/ksys-app-template/dist/utils/changeCase';
import { ConditionalDisclaimers } from '../models/configuration/disclaimers/ConditionalDisclaimers';
import TabRegion from '../models/components/TabRegion';

interface FundTypeTabsProps {
    theme?: { [property: string]: string | number };
    dataStore?: DataStore;
    accessibilityStore?: AccessibilityStore;
    ConditionalDisclaimers?: ConditionalDisclaimers;
}

@inject('dataStore', 'accessibilityStore')
@observer
class FundTypeTabs extends Component<FundTypeTabsProps> {
    get tabsProps(): TabsProps {
        const { dataStore, theme } = this.props;
        const selectedFundTypeId = getFundTypeId(
            dataStore.config.selectedFundType as FundType
        );
        return {
            region: TabRegion.FundType,
            tabs: dataStore.config.fundTypes.map(fundType => {
                return {
                    id: getFundTypeId(fundType as FundType),
                    label: fundType.label,
                    disclaimers: (fundType as FundType).disclaimers,
                };
            }),
            setTabActive: tab => {
                dataStore.logDataLayer('tab_navigation', {
                    tabRegion: TabRegion.FundType,
                    tabLabel: tab.label,
                });
                dataStore.config.setFundType(tab);
            },
            isTabSelected: tabId => tabId === selectedFundTypeId,
            getMetricContext: tab => `fundTypeTabs-${camelCase(tab.label)}`,
            tabThemeOverride: theme.FundTypeTab,
        };
    }

    render() {
        const { theme, accessibilityStore } = this.props;
        return (
            <Tabs
                {...this.tabsProps}
                {...theme.FundTypeTabs}
                aria-label={accessibilityStore.fundTypesLandmark}
                superscriptScope={SuperscriptScope.module}
            />
        );
    }
}

export default withTheme(FundTypeTabs);



// WEBPACK FOOTER //
// ./src/Components/FundTypeTabs.tsx